import { render, staticRenderFns } from "./AddTrainingCenter.vue?vue&type=template&id=14ff3db4&scoped=true&"
import script from "./AddTrainingCenter.vue?vue&type=script&lang=js&"
export * from "./AddTrainingCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ff3db4",
  null
  
)

export default component.exports